import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"


const api = new APIClient();

// Get General Settings
export const getGeneralSettings = () :  any => api.get(url.GENERAL_SETTINGS, null)

// Get General Settings by Key
export const getGeneralSettingsByKey = (key: string) :  any => api.get(`${url.GENERAL_SETTINGS}/by-key/${key}`, null)

// Update General Settings
export const updateGeneralSettings = (id: string, payload: any) : any  => api.put(`${url.GENERAL_SETTINGS}/${id}`, payload);

// Create General Settings
export const createGeneralSettings = (payload: any) : any => api.create(url.GENERAL_SETTINGS, payload);

// Get Detail General Settings
export const getDetailGeneralSettings = (id: string) => api.get(`${url.GENERAL_SETTINGS}/${id}`, {});
